<div class="field column-left gap-4px width-100" #fieldGroups>
    <span class="field-title">Restricción</span>
    
    <app-only-sell class="width-100" [fieldIdentificator]="fieldIdentificator" (focusEvent)="emitField(fieldGroups)"></app-only-sell>
    <app-not-sell  class="width-100" [fieldIdentificator]="fieldIdentificator" (focusEvent)="emitField(fieldGroups)"></app-not-sell>
</div>